import * as React from 'react';

import { FIELD_PATHS, OTHER_OPTIONS } from '@funnels/constants';
import { LiabilityEntityIndex } from '@funnels/types';

import { AutoCompleteInputField, StringDisplay } from '../../Fields';
import loadLenders from '../_common/loadLenders';
import { EditableViewProps, FunnelViewProps, StringReadOnlyViewProps } from '../types';

interface CurrentLenderEditableViewProps extends EditableViewProps, LiabilityEntityIndex {
  label?: string;
  disableFailMessage?: boolean;
  menuContainerRef?: React.RefObject<HTMLUListElement>;
  validationFailMessage?: string;
}
export const CurrentLenderEditableView = (props: CurrentLenderEditableViewProps) => {
  return (
    <AutoCompleteInputField
      name={FIELD_PATHS.LIABILITY_FINANCIAL_INSTITUTION(props.liabilityIndex)}
      dataSource={loadLenders}
      label={props.label}
      placeholder={'Search for your lender'}
      validationFailMessage={props.validationFailMessage || 'Please select your current lender.'}
      isFullWidth
      disableFailMessage={props.disableFailMessage}
      isDisabled={props.isDisabled}
      isOptional={props.isOptional}
      backupOption={OTHER_OPTIONS}
      menuContainerRef={props?.menuContainerRef}
    />
  );
};

interface CurrentLenderFunnelViewProps extends FunnelViewProps, LiabilityEntityIndex {
  label?: string;
  className?: string;
}
export const CurrentLenderFunnelView = (props: CurrentLenderFunnelViewProps) => (
  <AutoCompleteInputField
    {...props}
    name={FIELD_PATHS.LIABILITY_FINANCIAL_INSTITUTION(props.liabilityIndex)}
    dataSource={loadLenders}
    isFullWidth
    label={props.label}
    placeholder={'Search for your lender'}
    validationFailMessage={'Please select your current lender.'}
    backupOption={OTHER_OPTIONS}
  />
);

export const CurrentLenderReadOnlyView = (props: StringReadOnlyViewProps) => (
  <StringDisplay title={'Lender'} value={props.value} />
);

export const CompanyCurrentLenderEditableView = ({ applicantIndex }: { applicantIndex: number }) => {
  return (
    <AutoCompleteInputField
      name={FIELD_PATHS.APPLICANT_COMPANY_CURRENT_LENDER(applicantIndex)}
      dataSource={loadLenders}
      label="Current lender"
      placeholder="Search..."
      isFullWidth
      isOptional
      backupOption={OTHER_OPTIONS}
    />
  );
};
